import React from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect, dispatch } from 'react-redux';
import { firebaseConnect, isLoaded, isEmpty, helpers as firebaseHelpers } from 'react-redux-firebase'
import Link from 'gatsby-link'
import { withRouter } from 'react-router';
import PropTypes from 'prop-types'; // ES6

class Subscribe extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
        name: '',
        email: '',
        zip: '',
        isSent: false,
        canSubmit: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkInput = this.checkInput.bind(this);

    this.url = window.location.hostname == 'localhost' ? "http://localhost:9000" : "/.netlify/functions";
  }
  handleChange(event) {
      console.debug(event.target.name);
      const field = event.target.name;
      this.setState({[field]: event.target.value});
      this.checkInput(event);
  }

  checkInput(event) {
    //An email can be a minimum of 5 characters a@a.aa
    console.debug("Updating canSubmit to: ", canSubmit)
    const canSubmit = this.state.email.length > 6 && this.state.name.length >= 2 && this.state.zip.length >= 5;
    this.setState({
      canSubmit: canSubmit
    });
  }

  trackSubscribe(){
    window.ga('send', {
      hitType: 'event',
      eventCategory: 'Mailing list',
      eventAction: 'Subscribed',
      eventLabel: 'Home page email form'
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    fetch(this.url+'/subscribe', {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(this.state)
    }).then((res) => {

      this.trackReferralMagicSignup(this.state)

      this.trackSubscribe()

      this.setState({
        isSent: true,
        canSubmit: false,
        name: '',
        email: '',
        zip: ''
      });

      document.querySelector('#subscribe form').reset();
      setTimeout(() => this.setState({ isSent: false }), 7500);
    }).catch(error => {
      console.debug(error);
    });

    return false;
  }

  trackReferralMagicSignup({ name, email }){
    if (window.rfmgc) {
      window.rfmgc('sign-up', { name, email })
    }
  }

  render() {
    const { location, children } = this.props
    return (
      <div id="subscribe" className="subscribe">
        <div className="message" style={{display: !this.state.isSent ? 'none' : 'block'}}>
            <p dangerouslySetInnerHTML={{__html: isLoaded(this.props.state.dashboard) ? this.props.state.dashboard.subscribeMessage.replace(/{Name}/g, this.state.name.split(' ')[0]) : 'Thanks for subscribing!'}}></p>
        </div>
        <form method="post" onSubmit={this.handleSubmit} style={{display: this.state.isSent ? 'none' : 'block'}}>
            <div className={`content`}>
                <div className="fields">
                <div className="field first">
                    <label htmlFor="name">Name:</label>
                    <input disabled={this.state.isSent} type="text" required name="name" id="name"
                    value={this.state.name}
                    onChange={this.handleChange}
                    onBlur={this.checkInput}/>
                </div>
                <div className="field-group">
                    <div className="field half">
                    <label htmlFor="email">Email:</label>
                    <input disabled={this.state.isSent} type="email" required name="email" id="email"
                        onChange={this.handleChange}
                        onBlur={this.checkInput}/>
                    </div>
                    <div className="field half zipcode">
                    <label htmlFor="email">Zip:</label>
                    <input disabled={this.state.isSent} type="text" required name="zip" id="zip"
                        onChange={this.handleChange}
                        onBlur={this.checkInput}/>
                    </div>
                </div>
                </div>
                <ul className="actions">
                <li><input type="submit" value="Send" disabled={this.state.isSent || !this.state.canSubmit} /></li>
                </ul>
            </div>
        </form>
    </div>
    )
  }
}

Subscribe.propTypes = {
  route: PropTypes.object
}

const  mapStateToProps = ({app, firebase}) => ({
  state: {
    subscribe: app.subscribe,
    dashboard: firebase.data.dashboard
  }
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
  connect(
      mapStateToProps,
      mapDispatchToProps
  )
)(withRouter(Subscribe))


// WEBPACK FOOTER //
// ./src/components/Subscribe.js